export enum TransactionType {
    DEPOSIT = 'Deposit',
    BONUS = 'Bonus',
    WITHDRAWAL = 'Withdrawal'
}